import type { Session } from "@mux/sdk/v2/client"

// Runtime-owned session metadata, additive to the generated upstream contract.
export type SnoozableSession = Session & { snoozedUntil?: number; sidebarAt?: number }

export function sessionSnoozedUntil(session: Session) {
  return (session as SnoozableSession).snoozedUntil ?? 0
}

export function sessionSidebarAt(session: Session) {
  return Math.max((session as SnoozableSession).sidebarAt ?? 0, session.time.activity ?? session.time.updated ?? session.time.created)
}
